import * as React from "react";

export function usePrevious<T>(value: T): undefined | T {
    const ref = React.useRef<T>();
    React.useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}
